const button = document.querySelector(".navbar-toggler");
const menu = document.querySelector("#navbarNavAltMarkup");

button.addEventListener("click", () => {
  if (menu.classList.contains("show")) {
    console.log('clicked');
    setTimeout(() => {
      $('#navbarNavAltMarkup').collapse('hide');
    }, 500);
  }
});
